/* eslint-disable max-len */
export default {
  getCustomer: (state) => state.customer,
  activeCustomer: (state) => state.activeCustomer,
  isOnHold: (state) => state.activeCustomer?.status === 2,
  restaurantTypes: (state) => state.restaurantTypes.sort(),
  getCustomerById: (state) => (id) => state.customers.find((c) => c.customerId === parseInt(id, 10)),
};
